import BaseManager from "./BaseManager";
import Facade from "@/Facade";
import '../externals/ppb-game-client-api-1.0.8'
import Signals from "@/signals/GameSignals";

export const GAN_RECEIVE_MESSAGE_TYPES = {
    GAME_PROCEED: 'gameProceed',
    GAME_PAUSE: 'gamePause',
    REFRESH_BALANCE: 'refreshBalance',
    FAILED_COMMUNICATION: 'failedCommunication',
    CONNECTION_ESTABLISHED: 'connectionEstablished',
    RESIZE_GAME: 'resizeGame'
}

export const GAN_SEND_MESSAGE_TYPES  = {
    GAME_LOADED: 'gameLoaded',
    GAME_LOAD_FAILED: 'gameLoadFailed',
    GAME_CLOSING:'gameClosing',
    PLAY_STARTED: 'playStarted',
    PLAY_STOPPED: 'playStopped',
    FATAL_ERROR: 'fatalError',
    UI_ENABLE: 'uiEnable',
    UI_DISABLE: 'uiDisable',
    HIDE_LOADER: 'hideLoader',
    SHOW_LOADER: 'showLoader'
}

export default class GanManager extends BaseManager {
    gan;
    ganEventDispatch;

    constructor() {
        super()
    }

    init(adapter) {
        super.init(adapter)
    }

    relaxConfigure(data) {
        this.gan = window.gan;
        if(this.gan) this.ganEventDispatch = window.ganEventDispatch;
        if(this.gan) this.gan.addGANOnEventReceiveCallback(this.ganEventReceive.bind(this))
    }

    loadCompleted() {
      if(this.ganEventDispatch) this.ganEventDispatch(GAN_SEND_MESSAGE_TYPES.GAME_LOADED)
    }

    roundStart(value = 0) {
        if(this.ganEventDispatch) this.ganEventDispatch(GAN_SEND_MESSAGE_TYPES.PLAY_STARTED)
    }

    roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
        if(this.ganEventDispatch)  this.ganEventDispatch(GAN_SEND_MESSAGE_TYPES.PLAY_STOPPED)
    }

    ganEventReceive(payload) {
        if(!this.gan) return;
        console.log('::: GAN EVENT RECEIVED ', payload)

        switch (payload.msg) {
            case GAN_RECEIVE_MESSAGE_TYPES.GAME_PROCEED:
                this.adapter.unfreeze()
                break
            case GAN_RECEIVE_MESSAGE_TYPES.GAME_PAUSE:
                this.adapter.freeze()
                break
            case GAN_RECEIVE_MESSAGE_TYPES.REFRESH_BALANCE:
                this.adapter.updateBalance()
                break
            case GAN_RECEIVE_MESSAGE_TYPES.FAILED_COMMUNICATION:
                //KILL INTEGRATION SOMEHOW
                break
        }
    }
}
